module.exports = __webpack_public_path__ + "img/estructura_excel.a8895668.png";